const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;
const Lenis = window.Lenis;

if (gsap && ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

const preloader = document.getElementById("preloader");
window.addEventListener("load", () => {
  if (!gsap) {
    if (preloader) preloader.style.display = "none";
    return;
  }
  const tl = gsap.timeline({ delay: 0.15 });
  tl.to(".preloader__mark", { opacity: 1, duration: 0.5, ease: "power1.out" })
    .to(".preloader__mark", { opacity: 0, duration: 0.4, delay: 0.35, ease: "power1.in" })
    .to(preloader, {
      yPercent: -100, duration: 0.9, ease: "power4.inOut",
      onComplete: () => { if (preloader) preloader.style.display = "none"; ScrollTrigger.refresh(); }
    })
    .fromTo("[data-hero] .hero__content [data-reveal]",
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, stagger: 0.1, ease: "power3.out" }, "-=0.5")
    .fromTo("[data-hero] .hero__scroll",
      { opacity: 0 },
      { opacity: 0.75, duration: 0.8 }, "-=0.4");
});

let lenis;
if (Lenis) {
  lenis = new Lenis({
    duration: 1.15,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    autoRaf: false,
  });
  lenis.on("scroll", () => ScrollTrigger && ScrollTrigger.update());
  if (gsap) {
    gsap.ticker.add((time) => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);
  } else {
    requestAnimationFrame(function raf(t) { lenis.raf(t); requestAnimationFrame(raf); });
  }
}

const header = document.querySelector("[data-header]");
const menuToggle = document.querySelector("[data-menu-toggle]");
const mobileNav = document.querySelector("[data-mobile-nav]");

window.addEventListener("scroll", () => {
  if (!header) return;
  header.classList.toggle("is-condensed", window.scrollY > 40);
}, { passive: true });

if (menuToggle && mobileNav) {
  menuToggle.addEventListener("click", () => {
    mobileNav.classList.toggle("is-open");
  });
  mobileNav.querySelectorAll("a").forEach((a) => {
    a.addEventListener("click", () => mobileNav.classList.remove("is-open"));
  });
}

if (gsap && ScrollTrigger) {
  const reveals = gsap.utils.toArray("[data-reveal]").filter(
    (el) => !el.closest("[data-hero]")
  );
  reveals.forEach((el) => {
    gsap.fromTo(el,
      { y: 26, opacity: 0 },
      {
        y: 0, opacity: 1, duration: 0.9, ease: "power3.out",
        scrollTrigger: { trigger: el, start: "top 88%" }
      }
    );
  });

  const manifesto = document.querySelector("[data-split-reveal]");
  if (manifesto) {
    const words = manifesto.textContent.trim().split(/\s+/);
    manifesto.innerHTML = words.map((w) => `<span class="word">${w}</span>`).join(" ");
    gsap.to(manifesto.querySelectorAll(".word"), {
      opacity: 1,
      stagger: 0.06,
      ease: "none",
      scrollTrigger: {
        trigger: manifesto,
        start: "top 80%",
        end: "bottom 55%",
        scrub: 0.5,
      },
    });
  }

  gsap.utils.toArray("[data-reveal-clip]").forEach((el, i) => {
    gsap.fromTo(el,
      { clipPath: "inset(100% 0 0 0)" },
      {
        clipPath: "inset(0% 0 0 0)",
        duration: 1.1,
        ease: "power4.out",
        scrollTrigger: { trigger: el, start: "top 92%" },
      }
    );
    gsap.fromTo(el.querySelector("img"),
      { scale: 1.22 },
      {
        scale: 1,
        duration: 1.3,
        ease: "power3.out",
        scrollTrigger: { trigger: el, start: "top 92%" },
      }
    );
  });

  gsap.utils.toArray("[data-parallax-img]").forEach((wrap) => {
    const img = wrap.querySelector("img");
    gsap.fromTo(img,
      { scale: 1.22, yPercent: -6 },
      {
        scale: 1, yPercent: 6, ease: "none",
        scrollTrigger: { trigger: wrap, start: "top bottom", end: "bottom top", scrub: true },
      }
    );
  });

  gsap.to("[data-hero] .hero__content", {
    yPercent: 20, opacity: 0.4, ease: "none",
    scrollTrigger: { trigger: "[data-hero]", start: "top top", end: "bottom top", scrub: true },
  });
}

const ctaCanvas = document.querySelector("[data-cta-canvas]");
if (ctaCanvas) {
  const ctx = ctaCanvas.getContext("2d");
  let w, h, particles;

  function initParticles() {
    const rect = ctaCanvas.parentElement.getBoundingClientRect();
    w = ctaCanvas.width = rect.width;
    h = ctaCanvas.height = rect.height;
    const count = Math.round((w * h) / 26000);
    particles = Array.from({ length: count }, () => ({
      x: Math.random() * w,
      y: Math.random() * h,
      r: Math.random() * 1.4 + 0.3,
      speed: Math.random() * 0.15 + 0.03,
      drift: (Math.random() - 0.5) * 0.15,
      alpha: Math.random() * 0.4 + 0.1,
    }));
  }

  function draw() {
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = "#efe8db";
    particles.forEach((p) => {
      p.y -= p.speed;
      p.x += p.drift;
      if (p.y < -10) { p.y = h + 10; p.x = Math.random() * w; }
      ctx.globalAlpha = p.alpha;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.globalAlpha = 1;
  }

  let ctaVisible = false;
  if ("IntersectionObserver" in window) {
    new IntersectionObserver((entries) => { ctaVisible = entries[0].isIntersecting; }, { threshold: 0 })
      .observe(ctaCanvas.parentElement);
  } else {
    ctaVisible = true;
  }

  initParticles();
  window.addEventListener("resize", initParticles);

  function loop() {
    requestAnimationFrame(loop);
    if (!ctaVisible) return;
    draw();
  }
  loop();
}
